export default __webpack_public_path__ + "static/media/cordex.8a1b40bb.png";